export const USER_REQUEST='USER_REQUEST';
export const USER_SUCCESS='USER_SUCCESS';
export const USER_FAIL='USER_FAIL';


export const REGISTER_USER_REQUEST='REGISTER_USER_REQUEST';
export const REGISTER_USER_SUCCESS='REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAIL='REGISTER_USER_FAIL';

export const LOAD_USER_REQUEST='LOAD_USER_REQUEST';
export const LOAD_USER_SUCCESS='LOAD_USER_SUCCESS';
export const LOAD_USER_FAIL='LOAD_USER_FAIL';

export const LOGOUT_USER_SUCCESS='LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAIL='LOGOUT_USER_FAIL';

export const UPDATE_USER_REQUEST='UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS='UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL='UPDATE_USER_FAIL';

export const CHANGE_PASSWORD_REQUEST='CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS='CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL='CHANGE_PASSWORD_FAIL';


export const ADMIN_USERS_REQUEST='ADMIN_USERS_REQUEST';
export const ADMIN_USERS_SUCCESS='ADMIN_USERS_SUCCESS';
export const ADMIN_USERS_FAIL='ADMIN_USERS_FAIL';

export const ADMIN_USER_ROLE_UPDATE='ADMIN_USER_ROLE_UPDATE';


export const CLEAR_USER_ERRORS='CLEAR_ERRORS'
